module.exports = __webpack_public_path__ + "img/tarot-major-arcana-06.f589e456.png";